import * as React from "react"
import { Slot } from "@radix-ui/react-slot"
import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils"

const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-lg text-sm font-medium transition-all duration-150 ease-in-out focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[hsl(var(--gold))] focus-visible:ring-offset-2 focus-visible:ring-offset-[hsl(var(--bg))] active:translate-y-[1px] disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        default:
          "bg-[hsl(var(--gold))] text-[#1a1a1a] hover:brightness-95 hover:shadow-[0_2px_10px_hsla(35,47%,60%,0.35)] active:brightness-90 active:shadow-[inset_0_0_0_2px_hsla(35,47%,60%,0.55)]",
        destructive:
          "bg-[hsl(var(--loss))] text-[hsl(var(--bg))] hover:brightness-95 hover:shadow-[0_2px_8px_hsla(0,36%,54%,0.30)] active:brightness-90",
        outline:
          "border border-[hsl(var(--border-strong))] bg-transparent text-[hsl(var(--text))] hover:border-[hsl(var(--gold))] hover:text-[hsl(var(--gold))] hover:bg-[hsla(35,47%,60%,0.08)] active:bg-[hsla(35,47%,60%,0.14)]",
        secondary:
          "bg-[hsl(var(--surface))] text-[hsl(var(--text))] border border-[hsl(var(--border-strong))] hover:border-[hsl(var(--gold))] hover:text-[hsl(var(--gold))] active:shadow-[inset_0_0_0_2px_hsla(35,47%,60%,0.30)]",
        ghost:
          "bg-transparent text-[hsl(var(--text))] hover:bg-[hsla(35,47%,60%,0.10)] hover:text-[hsl(var(--gold))] active:bg-[hsla(35,47%,60%,0.18)]",
        link: "text-[hsl(var(--gold))] underline-offset-4 hover:underline",
      },
      size: {
        default: "h-10 px-4 py-2",
        sm: "h-8 rounded-md px-3 text-xs",
        lg: "h-11 rounded-lg px-6 text-base",
        icon: "h-9 w-9",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
)

const Button = React.forwardRef(({ className, variant, size, asChild = false, ...props }, ref) => {
  const Comp = asChild ? Slot : "button"
  return (
    <Comp
      className={cn(buttonVariants({ variant, size, className }))}
      ref={ref}
      {...props} />
  );
})
Button.displayName = "Button"

export { Button, buttonVariants }
